import BaseApi from "./BaseApi";
//import { serverURL } from '../constants/constants';
//import { requestData3Pax } from './mockRequestData';
import qs from "qs";

export const getDeals = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/deals/GetDeals?${reqStr}`);
  return result;
};

export const getDealDetail = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/deals/GetDeal?${reqStr}`);
  return result;
};

export const doDealSearch = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/deals/GetPackageSearch?${reqStr}`);
  return result;
};



// WEBPACK FOOTER //
// ./src/api/deals.js